import isEmpty from 'lodash/isEmpty'
import isUndefined from 'lodash/isUndefined'
import isEqual from 'lodash/isEqual'
import { IFeed, IFeedEdited } from '@/types/feeds'
import { IScheduleModal, ISchedule } from '@/types/schedules'
import { USER_PREFERENCES_TIMEZONE } from './date'

export const FEED_COMMON_PROPS = [
  'name',
  'investment_item',
  'investment_object_type',
  'delivery_type',
  'delivery_destination',
  'attestation_form',
]

export const INVESTMENT_PROPS = [
  'data_set',
  'format_column_names',
  'file_format',
  'csv_txt_include_quoting',
  'txt_include_delimiter',
  'json_include_lines',
  'file_compression',
]

export const SCHEDULE_PROPS = [
  'name',
  'repeatType',
  'dateType',
  'startDay',
  'runningTime',
  'timezone',
  'fixedDay',
  'ordinal',
  'weekday',
  'subscribeFtpTriggerFile',
]

export const compareObjects = (
  feed: Record<string, IFeed>,
  editedFeed: Record<string, IFeedEdited>,
  props: string[]
): boolean => {
  for (const prop of props) {
    if (!isEqual(feed[prop], editedFeed[prop])) {
      return true // Found a difference
    }
  }
  return false // No differences found
}

const validatePropValue = (value: any): boolean =>
  !isUndefined(value) && !isEmpty(value)

export const formatEditSchedule = (
  editedSchedule: ISchedule
): IScheduleModal => {
  const editedScheduleFormatted: IScheduleModal = {
    name: editedSchedule.name,
    repeatType: editedSchedule.frequency.repeatType,
    dateType: editedSchedule.frequency.dateType,
    startDay: editedSchedule.start_day,
    runningTime: editedSchedule.running_time,
    timezone: editedSchedule.timezone ?? USER_PREFERENCES_TIMEZONE,
    fixedDay: editedSchedule.frequency.fixedDay,
    ordinal: editedSchedule.frequency.ordinal,
    weekday: editedSchedule.frequency.weekday,
    monthlyOpt: editedSchedule.frequency.monthlyOpt,
    subscribeFtpTriggerFile: editedSchedule.subscribeFtpTriggerFile || false,
  }

  return editedScheduleFormatted
}

export const compareSchedules = (
  schedule: Record<string, IScheduleModal>,
  editedSchedule: Record<string, IScheduleModal>,
  props: string[]
): boolean => {
  for (const prop of props) {
    if (
      (validatePropValue(schedule[prop]) ||
        validatePropValue(editedSchedule[prop])) &&
      !isEqual(schedule[prop], editedSchedule[prop])
    ) {
      return true // Found a difference
    }
  }
  return false // No differences found
}

export default compareObjects
